<template>
  <div :class="[ 'text-field', (width) ? `col-sm-${width}` : `col-sm-12` ]">
    <label :for="componentid">{{ label }}</label>
    <div :class="[isInputGroup, isBorderless]">
      <span class="input-group-addon" v-if="laddon">
        <slot name="before"></slot>
      </span>

      <textarea class="form-control"
        autocomplete="off"
        :id="componentid"
        :placeholder="placeholder"
        :value="value"
        :readonly="disabled"
        :rows="rows"
        @input="handle"
        @keypress="keypress"
        @paste="paste"
        />

      <span class="input-group-addon" v-if="raddon">
        <slot name="after"></slot>
      </span>
    </div>
    <p class="sublabel" v-html="sublabel"></p>
  </div>
</template>

<script>
import forceucase from '@/helpers/forminput-forceupper'

export default {
  props: {
    id: String,
    value: {},

    label: String,
    sublabel: String,
    placeholder: String,

    width: String,
    rows: {
      type: Number,
      default: 3
    },
    laddon: {
      type: Boolean,
      default: false,
    },
    raddon: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    forceupper: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      input: null,
    }
  },
  computed: {
    componentid() {
      if (this.id) return this.id

      return this.label ? this.label.toLowerCase().replace(' ', '') : ``
    },
    isInputGroup() {
      return (this.laddon || this.raddon) ? `input-group` : ``
    },
    isBorderless() {
      return this.borderless ? `borderless` : ``
    },
  },
  methods: {
    handle(event) {
      this.data = event.target.value || null
      this.$emit(`input`, this.data)
    },
    keypress(event) {
      if (event.keyCode === 13) this.$emit(`enter`, this.data)
      if (this.forceupper) forceucase(event)
    },
    paste(event) {
      if (this.forceupper) forceucase(event)
    }
  }
}
</script>

<style scoped>
  .sublabel {
    font-size: 80%;
    font-style: italic;
    margin-top: 5px;
    color: #999999;
  }

  .borderless input {
    background: none;
    border: none;
  }

  textarea {
    resize: none;
  }
</style>